export const BATCH_START = "BATCH_START";
export const BATCH_PROGRESS = "BATCH_PROGRESS";
export const BATCH_SUCCESS_ITEM = "BATCH_SUCCESS_ITEM";
export const BATCH_FAIL_ITEM = "BATCH_FAIL_ITEM";
export const BATCH_FINISH = "BATCH_FINISH";
export const BATCH_RESET = "BATCH_RESET";
export const BATCH_CLOSE_MODAL = "BATCH_CLOSE_MODAL";
export const BATCH_CANCEL = "BATCH_CANCEL";
export const BATCH_INIT_STATE = "BATCH_INIT_STATE";